<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">
        <Row type="container">
            <SearchCollapse :is-bg-white="true" :do-action="showCheckbox" class="position-relative top-6 right-0">
                <div class="grid grid-cols-3 gap-3 mb-3">
                    <div class="bg-red-400 text-white rounded flex justify-content-center align-items-center h-28">
                        <div class="px-3 text-center font-bold">
                            {{$t('expirationProduct.expiredProductsTotalAmount')}}
                            {{ expiredProductsTotalCount }}
                        </div>
                    </div>

                    <div class="bg-yellow-400 text-white rounded flex justify-content-center align-items-center h-28">
                        <div class="px-3 text-center font-bold">
                            {{$t('expirationProduct.productsFiveDaysLeftExpire')}}
                            {{ plusFiveDaysProductsTotalCount }}
                        </div>
                    </div>

                    <div class="bg-green-400 text-white rounded flex justify-content-center align-items-center h-28">
                        <div class="px-3 text-center font-bold">
                            {{$t('expirationProduct.productsTenDaysLeftExpire')}}
                            {{ plusTenDaysProductsTotalCount }}
                        </div>
                    </div>
                </div>
            </SearchCollapse>
        </Row>
        <RowColumn class="mx-2">
            <table class="w-full mt-4">
                <thead class="h-11 bg-lightGray">
                <tr>
                    <th v-if="canManageProducts() && isShowCheckboxes">
                        <b-form-checkbox
                            class="d-inline"
                            size="lg"
                            v-model="isSelectedAll"
                            @change="selectAll()"
                        ></b-form-checkbox>
                    </th>
                    <th class="d-none d-lg-table-cell px-3"> #</th>
                    <th>{{ $t('product.name') }}</th>
                    <th>{{ $t('warehouse.title') }}</th>
                    <th>{{ $t('product.datePurchase') }}</th>
                    <th>{{ $t('product.expired') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(purchase, index ) of productPurchases"
                    :key="index"
                    class="h-11"
                >
                    <td v-if="canManageProducts() && isShowCheckboxes">
                        <b-form-checkbox
                            class="d-inline"
                            size="lg"
                            :value=purchase
                            v-model="selectedProducts"
                            @change="selectChange()"
                        ></b-form-checkbox>
                    </td>

                    <td class="d-none d-lg-table-cell px-3"> {{ index + 1 }}</td>
                    <td class="text-main font-bold max-w-sm">{{ purchase.product.name }}</td>
                    <td>
                        {{ purchase.warehouse.name }}
                        <span class="mb-7" style="left: 13px; font-size: 9px; border-radius: 100%; padding: 0 4px;">
                        ({{ purchase.warehouseAmount }} - {{ showUnitOfMeasure(purchase.product.unitOfMeasure) }})
                    </span>
                    </td>
                    <td>
                        {{ convertDateAnnouncement(purchase.createdAt) }}
                        <span class="mb-7" style="left: 13px; font-size: 9px; border-radius: 100%; padding: 0 4px;">
                        (+{{ purchase.amount }} {{ showUnitOfMeasure(purchase.product.unitOfMeasure) }},
                        <span v-if="purchase.soldAmount !== null && purchase.soldAmount !== 0">
                            {{$t('expirationProduct.soldOut')}} {{ purchase.soldAmount }}
                        </span>
                        <span v-else>
                            {{$t('expirationProduct.notSold')}}
                        </span>)
                    </span>
                    </td>
                    <td>
                        {{ convertDateAnnouncement(purchase.shelfLife) }}
                        <span class="mb-7" style="left: 13px; font-size: 9px; border-radius: 100%; padding: 0 4px;">
                        <span v-if="purchase.soldAmount !== null && purchase.soldAmount !== 0">
                            ({{ purchase.amount + purchase.soldAmount }} {{
                                showUnitOfMeasure(purchase.product.unitOfMeasure)
                            }})
                        </span>
                        <span v-else>
                            ({{ purchase.amount }} {{ showUnitOfMeasure(purchase.product.unitOfMeasure) }})
                        </span>
                    </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </RowColumn>
        <div>
            <b-button
                variant="danger"
                size="sm"
                v-if="selectedProducts.length > 0"
                style="background-color: red; color: #fff"
                class="d-flex float-right mx-2"
                @click="pushProductsWriteOffPage()"
            >
                {{$t('productsInWarehouse.writeOff')}}
            </b-button>
        </div>
    </Row>
</template>

<script>
import Row from "@/components/html/Row";
import {mapActions, mapGetters, mapMutations} from "vuex";
import accessMixin from "@/mixin/accessMixin";
import SearchCollapse from "@/components/SearchCollapse";
import sizeClassesMixin from "@/components/html/mixin/sizeClassesMixin";
import displayClassesMixin from "@/components/html/mixin/displayClassesMixin";
import RowColumn from "@/components/RowColumn.vue";

export default {
    name: "ExpirationProducts",
    components: {RowColumn, Row, SearchCollapse},
    mixins: [accessMixin, sizeClassesMixin, displayClassesMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: 'product.productExpired'},
            ],
            isSelectedAll: false,
            isShowCheckboxes: false,
            selectedProducts: [],
            productPurchases: [],
            expiredProductsTotalCount: 0,
            plusFiveDaysProductsTotalCount: 0,
            plusTenDaysProductsTotalCount: 0,
        }
    },
    computed: {
        ...mapGetters([
            'getProductsExpirationDateNear',
            'getProductsExpirationDateNearTotalCount'
        ]),
    },
    methods: {
        ...mapActions([
            'fetchProductsExpirationDateNear',
            'setBreadcrumbItems'
        ]),
        ...mapMutations(['updateProductsExpiredWriteOff']),
        pushProductsWriteOffPage() {
            this.updateProductsExpiredWriteOff(this.identicalSelectedProducts())
            this.$i18nHelper.toUrl('expired-product-write-off')

        },
        isProductSelected(identicalProducts, selectedProduct) {
            for (const identicalProduct of identicalProducts) {
                if (identicalProduct.prodactInWarehouseId === selectedProduct.prodactInWarehouseId) {
                    return true
                }
            }

            return false
        },
        identicalSelectedProducts() {
            let identicalProducts = []

            for (let selectedProduct of this.selectedProducts) {
                if (identicalProducts.length !== 0) {
                    if (!this.isProductSelected(identicalProducts, selectedProduct)) {
                        identicalProducts.push(selectedProduct);
                    } else {
                        for (let identicalProduct of identicalProducts) {
                            if(identicalProduct.prodactInWarehouseId === selectedProduct.prodactInWarehouseId){
                                if (selectedProduct.soldAmount === null) {
                                    identicalProduct.amount = identicalProduct.amount + selectedProduct.amount
                                } else {
                                    identicalProduct.amount = identicalProduct.amount + (selectedProduct.amount + selectedProduct.soldAmount)
                                }
                            }
                        }
                    }
                } else {
                    identicalProducts.push(selectedProduct);
                }
            }

            return identicalProducts;
        },
        selectChange() {
            this.isSelectedAll = this.selectedProducts.length === this.productPurchases.length;
        },
        selectAll() {
            if (this.isSelectedAll) {
                this.productPurchases.map((item) => {
                    this.selectedProducts.push(item)
                })
            } else {
                this.selectedProducts = []
            }
        },
        showCheckbox() {
            this.isShowCheckboxes = !this.isShowCheckboxes

            if (!this.isShowCheckboxes) {
                this.selectedProducts = []
            }
        },
        showUnitOfMeasure(unit) {
            if (unit === undefined) {
                return ''
            }

            if (Object.prototype.hasOwnProperty.call(this.$i18n.messages.en.unitOfMeasure, unit)) {
                return this.$t('unitOfMeasure.' + unit)
            }

            return unit
        },
        convertDateAnnouncement(inputFormat) {
            function pad(s) {
                return (s < 10) ? '0' + s : s;
            }

            let d = new Date(inputFormat)
            return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('.')
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchProductsExpirationDateNear()
            .then(() => {
                this.expiredProductsTotalCount = this.getProductsExpirationDateNear[0].length
                this.plusFiveDaysProductsTotalCount = this.getProductsExpirationDateNear[1].length
                this.plusTenDaysProductsTotalCount = this.getProductsExpirationDateNear[2].length

                for (let expirationDateNear of this.getProductsExpirationDateNear) {
                    for (let expiredProducts of expirationDateNear) {
                        this.productPurchases.push(expiredProducts)
                    }
                }
            })
    }
}
</script>

<style scoped>
table tbody tr {
    border-bottom: 1px solid #eaeaea;
}
</style>